class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      product: '.product-information',
      sellingPlanGroups: '[data-selling-plan-group-selector]',
      sellingPlans: '[data-selling-plan-selector]',
      sellingPlansWrapper: '[data-selling-plans-wrapper]'
    };

    this.productSelector = this.closest(
      this.selectors.product
    ).querySelector('product-selector');
    this.productForm = this.closest(
      this.selectors.product
    ).querySelector('product-form');
  }

  connectedCallback() {
    this.setHandlers();
  }

  setHandlers() {
    this.querySelector(
      this.selectors.sellingPlanGroups
    ).addEventListener(
      'change',
      this.onSellingGroupChange.bind(this)
    );
    this.querySelectorAll(this.selectors.sellingPlans).forEach(
      (sellingPlanContainer) =>
        sellingPlanContainer.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) {
            event.target
              .closest('[data-selling-plan-selector]')
              ?.classList?.remove('has-error');
            this.updateProductSelector(event.target.value);
          }
        })
    );
  }

  onSellingGroupChange(event) {
    const radio = event.target;
    if (!radio.matches('input[type="radio"][name="selling_plan_group"]')) return;
    const sellingPlansWrapper = this.querySelector(
      this.selectors.sellingPlansWrapper
    );
    if (!sellingPlansWrapper) return;

    if (radio.value === 'one-time') {
      this.querySelectorAll(
        'input[name="selling_plan"]:checked'
      ).forEach((r) => {
        r.checked = false;
      });
      this.updateProductSelector();
      sellingPlansWrapper.style.removeProperty('max-height');
      sellingPlansWrapper.style.removeProperty('overflow');
      sellingPlansWrapper.classList.add('is-hidden');
      sellingPlansWrapper.hidden = true;
      return;
    }

    sellingPlansWrapper.hidden = false;
    sellingPlansWrapper.classList.remove('is-hidden');
    const sellingPlansWrapperId = radio.dataset.id;
    sellingPlansWrapper
      .querySelectorAll('[data-id]')
      .forEach((sellingGroupWrapper) => {
        sellingGroupWrapper.classList.toggle(
          'is-hidden',
          sellingGroupWrapper.dataset.id !== sellingPlansWrapperId
        );
      });
    sellingPlansWrapper.style.maxHeight = `${sellingPlansWrapper.scrollHeight}px`;
    sellingPlansWrapper.style.overflow = '';
  }

  isOneTimePurchase() {
    const checked = this.querySelector(
      '[name="selling_plan_group"]:checked'
    );
    return checked ? checked.value === 'one-time' : true;
  }

  showError() {
    const sellingPlanWrappers = this.querySelectorAll(
      this.selectors.sellingPlansWrapper
    );
    const activeSellingPlanWrapper = [...sellingPlanWrappers].find(
      (wrapper) => !wrapper.classList.contains('is-hidden')
    );
    if (activeSellingPlanWrapper) {
      activeSellingPlanWrapper
        .querySelectorAll('[data-selling-plan-selector]')
        .forEach((el) => el.classList.add('has-error'));
    }
  }

  updateProductSelector(sellingPlanId) {
    if (!this.productSelector || !this.productForm) return;

    if (!this.productSelector.currentVariant) {
      this.productSelector.updateVariant();
    }

    this.productSelector.updateURL(sellingPlanId);
    this.productSelector.renderProductInfo();
    if (
      this.productSelector.currentVariant?.available &&
      sellingPlanId
    ) {
      this.productForm.setAttribute('data-has-selling-plan', 'true');
      this.productForm.toggleAddButton(false, '');
      return;
    }

    this.productForm.removeAttribute('data-has-selling-plan');
    this.productForm.toggleAddButton(false, '');
  }
}

customElements.define('purchase-options', PurchaseOptions);
